<!-- Content linked to jobs -->
<template>
  <div>
    <b-row>
      <b-col style="border-right: 1px solid #e2e8f0;" lg='6'>
        <!-- Display content -->
        <div class="mt-3" role="displayContent">
          <b-row class="m-0">
            <label>What content would you like posted?</label>
          </b-row>
          <b-row class="m-0">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="display-content-options" id="link" value="link"
                v-model="form.customFields.displayContent">
              <label class="form-check-label" for="link">Link</label>
            </div>
            <!-- <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="display-content-options" id="image" value="image"
                v-model="form.customFields.displayContent">
              <label class="form-check-label" for="image">Image</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="display-content-options" id="document" value="document"
                v-model="form.customFields.displayContent">
              <label class="form-check-label" for="document">Document</label>
            </div>
            <div class="form-check form-check-inline">
               <input class="form-check-input" type="radio" name="display-content-options" id="video" value="video" v-model="form.customFields.displayContent">
               <label class="form-check-label" for="video">Video</label>
            </div> -->
          </b-row>
          <b-row class="m-0 mt-1">
            <p>Content linked to jobs must be posted as a link.</p>
          </b-row>
        </div>

        <!-- Content URL -->
        <div class="mt-3" role="url" v-if="form.customFields.displayContent === 'link'">
          <label for="input-url">URL (optional):</label>
          <b-row>
            <b-col cols="9">
              <b-form-input id="input-url" v-model="form.url" :state="urlState"
                aria-describedby="input-url-help input-url-feedback" placeholder="URL of your content"
                :disabled="$apollo.queries.prefetchedContentShare.loading" trim></b-form-input>
            </b-col>
            <b-col cols="3" class="d-flex justify-content-end align-items-end">
              <b-button variant="primary" @click="fetchContent"
                :disabled="$apollo.queries.prefetchedContentShare.loading || !urlState">
                Fetch Details
              </b-button>
            </b-col>
          </b-row>

          <b-form-invalid-feedback id="input-live-feedback">
            Enter a valid URL
          </b-form-invalid-feedback>

          <b-form-text id="input-live-help">The URL of the content you want to be imported onto Real Links, it can be a
            <b>YouTube</b> or <b>Vimeo</b> link as well.</b-form-text>
        </div>

        <!-- Upload document -->
        <div v-if="form.customFields.displayContent === 'document'" class="my-3">
          <b-row>
            <asset-block
            id="input-pdf-asset"
            class="pb-0 mb-0 pl-3"
            accept=".pdf"
            :field="{ type: 'DOCUMENT', label: 'Upload document:' }"
            v-model="form.document" :disabled="$apollo.queries.prefetchedContentShare.loading"
            :state="documentState"
            />
          </b-row>
          <b-row class="py-0">
            <b-col class="py-0">
              <b-form-text id="input-image-help">Upload a document (not bigger than 100Mb) that will be displayed on the social media platforms. We accept only .pdf format.</b-form-text>
            </b-col>
          </b-row>
        </div>

        <!-- Upload video -->
        <div v-if="form.customFields.displayContent === 'video'" class="my-3">
          <b-row>
            <asset-block
              showProgress
              class="pb-0 mb-0 pl-3"
              accept=".mp4"
              :field="{ type: 'VIDEO', label: 'Upload video:' }"
              v-model="form.video"
              :disabled="$apollo.queries.prefetchedContentShare.loading"
              :state="videoState"
            />
          </b-row>
          <b-row class="py-0">
            <b-col class="py-0">
              <b-form-text id="input-image-help">Upload a video (between 75Kb and 500Mb) that will be displayed on the social media platforms. We accept only .mp4 format.</b-form-text>
            </b-col>
          </b-row>
        </div>

        <hr class="my-4" v-if="form.customFields.displayContent === 'document' || form.customFields.displayContent === 'video'"/>

        <!-- Upload image -->
        <div class="mt-3" role="image">
          <b-row class="py-0">
            <b-col lg="5" class="py-0">
              <label for="input-image">URL of the image:</label>
              <b-form-input
                id="input-image"
                v-model="form.imageURL"
                placeholder="URL of the image"
                :disabled="$apollo.queries.prefetchedContentShare.loading"
                trim
                :state="imageState"
                ></b-form-input>
            </b-col>
            <b-col lg="1" class="p-0" style="align-self: end; text-align: center; line-height: 40px;">OR</b-col>
            <b-col lg="6" class="pt-1">
              <asset-block
                  id="input-image-asset"
                  class="pb-0
                  mb-0"
                  :field="{ type: 'IMAGE', label: 'Upload image:' }"
                  v-model="form.image"
                  accept="image/*"
                  :disabled="$apollo.queries.prefetchedContentShare.loading"
                  :state="imageState"
                />
            </b-col>
          </b-row>
          <b-row class="py-0">
            <b-col class="py-0" v-if="form.customFields.displayContent === 'document' || form.customFields.displayContent === 'video'">
              <b-form-text id="input-image-help">The image that will be attached to your content share. Add a link to the image or upload a file not bigger than 5Mb.</b-form-text>
            </b-col>
            <b-col class="py-0" v-else>
              <b-form-text id="input-image-help">The image that will be attached to your content share and will be displayed on social media platforms. Add a link to the image or upload a file not bigger than 5Mb.</b-form-text>
            </b-col>
          </b-row>
        </div>

        <hr class="my-4" />

        <!-- Content Title -->
        <div class="mt-3" role="title">
          <label for="input-title">Title:</label>
          <b-form-input id="input-title" v-model="form.title" :state="titleState"
            aria-describedby="input-title-help input-title-feedback" placeholder="Title of your content"
            :disabled="$apollo.queries.prefetchedContentShare.loading" trim></b-form-input>

          <b-form-invalid-feedback id="input-title-feedback">
            Enter at least 3 letters
          </b-form-invalid-feedback>
        </div>

        <hr class="my-4" />

        <!-- Content -->
        <div class="mt-3" role="content">
          <label for="input-content">Content:</label>
          <rich-text-field v-if="!$apollo.queries.prefetchedContentShare.loading"
            :placeholder="$t('content-fetch.placeholders.description')" v-model="form.content" />
          <b-textarea v-else :disabled="true" placeholder="Loading content..." />

          <b-form-invalid-feedback id="input-title-feedback">
            Enter at least 10 words or provide a YouTube/Vimeo link in the URL field.
          </b-form-invalid-feedback>
        </div>

        <hr class="my-4" />

        <!-- Short description -->
        <div class="mt-3" role="description">
          <label for="input-description">Short description:</label>
          <b-form-textarea id="input-description" v-model="form.description" :state="descriptionState"
            :disabled="$apollo.queries.prefetchedContentShare.loading" aria-describedby="input-description-help"
            placeholder="A short description of your content" rows="3"></b-form-textarea>

          <b-form-invalid-feedback id="input-description-feedback">
            Enter at least 10 words.
          </b-form-invalid-feedback>

        </div>

        <hr class="my-4" />
        <!-- Tags -->
        <div class="mt-3" role="tags">
          <b-form-group label="Tags" label-for="tags">
            <multiselect
              id="tags"
              :options="this.tagOptions"
              v-model="tagValue"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
              placeholder="Search or add a tag"
              @open="onTouch"
            />
          </b-form-group>
          <b-alert
              class="mt-2"
              v-if="tagError" variant="danger"
              show
            >
            {{ tagError }}
          </b-alert>
        </div>

        <hr class="my-4" />

        <!-- Content Categories -->
        <div v-if="hasContentCategoriesEnabled" class="mt-3" role="content-categories">
          <b-form-group label="Categories" label-for="content-categories">
            <multiselect
              id="content-categories"
              :options="contentCategoryOptions"
              v-model="contentCategoryValue"
              :multiple="true"
              :taggable="true"
              @tag="addContentCategory"
              @input="onContentCategoryChange"
              placeholder="Search or add a content category"
              @open="onContentCategoryTouch"
              track-by="id"
              label="name"
            />
          </b-form-group>
          <b-alert
              class="mt-2"
              v-if="contentCategoryError" variant="danger"
              show
            >
            {{ contentCategoryError }}
          </b-alert>
        </div>

        <hr v-if="hasContentCategoriesEnabled" class="my-4" />

        <!-- Job Selector -->
        <div>
          <b-card>
            <b-form-group label="Related Jobs" v-slot="{ ariaDescribedby }">
              <b-form-radio v-model="form.relatedJobs" :aria-describedby="ariaDescribedby" name="some-radios"
                value="NO_JOBS">No jobs</b-form-radio>
              <b-form-radio v-model="form.relatedJobs" :aria-describedby="ariaDescribedby" name="some-radios"
                value="CAMPAIGN_JOBS">Jobs from current campaigns</b-form-radio>
              <b-form-radio v-model="form.relatedJobs" :aria-describedby="ariaDescribedby" name="some-radios"
                value="ALL_JOBS">All active jobs</b-form-radio>
              <b-form-radio v-model="form.relatedJobs" :aria-describedby="ariaDescribedby" name="some-radios"
                value="SEGMENTED_JOBS">Jobs matching a selected criteria</b-form-radio>
            </b-form-group>

            <b-button @click="$bvModal.show('segmented-jobs-modal')" variant="primary"
              v-if="form.relatedJobs === 'SEGMENTED_JOBS'">
              Select criteria for related jobs
            </b-button>

            <b-form-text id="input-content-share-text-help">Select what jobs you would like to display underneath your
              content.</b-form-text>
          </b-card>
        </div>
      </b-col>
      <b-col lg='6'>
        <!-- Example share text -->
        <div class="mt-3" role="content-share-text">
          <label for="input-content-share-text">Example share text:</label>
          <b-form-textarea
            id="input-content-share-text"
            v-model="form.customFields.contentShareText"
            :state="contentShareTextState"
            :disabled="$apollo.queries.prefetchedContentShare.loading"
            aria-describedby="input-content-share-text-help"
            placeholder="Example share text"
            trim
            rows="5"
            max-rows="5"
          ></b-form-textarea>
          <b-form-invalid-feedback id="input-description-feedback">
            Enter at least 5 words.
          </b-form-invalid-feedback>

          <b-form-text id="input-content-share-text-help">The text that will be suggested to your employees to include when they share on social media.</b-form-text>
        </div>

        <hr class="my-4" />

        <!-- Preview -->
        <social-media-preview :title="form.title" :url="form.url" :description="form.description"
          :disabled="$apollo.queries.prefetchedContentShare.loading"
          :imageURL="form.imageURL || (form.image ? form.image.fileLocation : '')"
          :shareText="form.customFields.contentShareText"
          :loading="$apollo.queries.prefetchedContentShare.loading"
          :postType="form.customFields.displayContent"
          :tags="cleanTags(tagValue)"          :documentURL="form.document && form.document.fileLocation"
          :videoSrc="form.video && form.video.fileLocation"
          />
        <p class="mt-3 text-muted"><small>*The illustration above is an example preview of how the post can look like on
            LinkedIn or on other social media channels.</small></p>
      </b-col>
    </b-row>
    <b-row class="mt-3 pt-3 border-top">
      <b-col class="py-0 d-flex justify-content-end align-items-end">
        <b-button variant="primary" @click="$emit('input', {
          ...form,
          url: form.url || null,
          customFields: {
            ...form.customFields,
            tags: JSON.stringify(tagValue),
            contentCategories: form.customFields.contentCategories,
          },
          image: form.image ? { id: form.image.id } : null,
          relatedJobSegment: form.relatedJobSegment ? JSON.stringify(form.relatedJobSegment) : null,
          document: form.document && form.customFields.displayContent === 'document' ? { id: form.document.id } : null,
          video: form.video && form.customFields.displayContent === 'video' ? { id: form.video.id } : null,
        })"
          :disabled="$apollo.queries.prefetchedContentShare.loading || !titleState || !descriptionState || !contentShareTextState || !documentState || !imageState || !videoState">
          Save Content
        </b-button>
      </b-col>
    </b-row>

    <!-- Display modal if SEGMENTED_JOBS option is selected -->
    <b-modal id="segmented-jobs-modal" title="Select criteria for related jobs" hide-footer size="xl">
      <update-job-segment :value="form.relatedJobSegment" @saveSegment="saveSegment" modal-layout />
    </b-modal>
  </div>
</template>

<script>
import AssetBlock from '@/components/settings/AssetBlock';
import SocialMediaPreview from '@/components/content-share/content-share-editor/SocialMediaPreview';
import PrefetchContentShareQuery from '@/graphql/queries/PrefetchContentShare.gql';
import RichTextField from '@/components/RichTextField';
import UpdateJobSegment from '@/components/campaign-admin/update-job-segment';
import { mapPreferences, mapRoot } from '@src/mixins/root';
import { sanitiseTags } from '@/lib/utils';
import Multiselect from 'vue-multiselect';
import gql from 'graphql-tag';

const FIND_CONTENT_CATEGORIES = gql`
  query GetContentCategories {
    company {
      id
      contentCategories(where: { deleted: false }) {
        id
        name
      }
    }
  }
`;

const CREATE_CONTENT_CATEGORY = gql`
  mutation createContentCategory($input: CreateContentCategoryInput!) {
    createContentCategory(input: $input) {
      id
      name
    }
  }
`;

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    tagOptions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AssetBlock,
    SocialMediaPreview,
    RichTextField,
    UpdateJobSegment,
    Multiselect
  },
  data() {
    const { value } = this;
    const { customFields } = value || {};
    const { contentShareText, displayContent, tags, contentCategories } = customFields || {};
    const tagValue = (tags && JSON.parse(tags)) || [];
    const contentCategoryIds = (contentCategories && JSON.parse(contentCategories)) || [];

    return {
      form: {
        title: value.title || '',
        description: value.description || '',
        url: value.url || '',
        image: value.image || null,
        imageURL: value.imageURL || null,
        content: value.content || '',
        relatedJobSegment: value.relatedJobSegment && value.relatedJobSegment.length ? JSON.parse(value.relatedJobSegment) : null,
        relatedJobs: value.relatedJobs || 'CAMPAIGN_JOBS',
        customFields: {
          contentShareText: contentShareText || '🚀 Excited to share this content! 🌟',
          displayContent: displayContent || 'link',
          tags: JSON.stringify(tagValue),
          contentCategories: JSON.stringify(contentCategoryIds),
        },
        document: value.document || null,
        video: value.video || null,
      },
      prefetchError: null,
      tagError: null,
      tagValue,
      contentCategoryOptions: [],
      contentCategoryValue: [],
      contentCategoryError: null,
    };
  },
  apollo: {
    prefetchedContentShare: {
      query: PrefetchContentShareQuery,
      variables() {
        const { form } = this;
        return { url: form.url };
      },
      manual: true,
      result({ data: { company }, loading }) {
        const { form } = this;
        if (!loading) {
          const { contentSharePrefetch } = company || {};
          const { image, ...contentShare } = contentSharePrefetch || {};
          console.log(contentShare);
          this.form = {
            ...form,
            imageURL: image || form.imageURL || null,
            title: contentShare.title || form.title || '',
            description: contentShare.description || form.description || '',
            content: contentShare.content || form.content || '',
          };
        }
      },
      error(error) {
        this.prefetchError = error;
      },
      tagError(error) {
        this.tagError = error;
      },
      skip() {
        const { isRecruiter, urlState, form, isEdit } = this;
        return !isRecruiter || !urlState || !form.url || isEdit;
      },
      fetchPolicy: 'network-only',
    },
    contentCategories: {
      query: FIND_CONTENT_CATEGORIES,
      variables: {
        page: 1,
        limit: 100,
      },
      update(data) {
        const categories = (data.company.contentCategories || []);

        // Update options
        this.contentCategoryOptions = categories;

        // Update selected categories with full objects from the fetched data
        const selectedIds = JSON.parse(this.form.customFields.contentCategories || '[]');
        this.contentCategoryValue = selectedIds
          .map((id) => categories.find((c) => c.id === id))
          .filter(Boolean); // Remove any undefined entries where ID wasn't found

        // Update the form data to reflect removed categories
        this.form.customFields.contentCategories = JSON.stringify(this.contentCategoryValue.map(cat => cat.id));
      },
      error(error) {
        console.error('Error fetching content categories:', error);
      },
    },
  },
  watch: {
    'form.relatedJobs': {
      handler() {
        const { relatedJobs } = this.form;
        if (relatedJobs === 'SEGMENTED_JOBS') {
          this.$bvModal.show('segmented-jobs-modal');
        }
      },
      immediate: false,
      deep: true
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),
    ...mapPreferences([ 'featuresEnabled' ]),
    hasContentCategoriesEnabled() {
      console.log(this.featuresEnabled);
      return (this.featuresEnabled || []).includes('content-categories');
    },
    urlState() {
      if (this.form.customFields.displayContent === 'link' && this.form.url.length > 0) {
        try {
          const url = new URL(this.form.url);
          if (url.protocol === 'http:' || url.protocol === 'https:') {
            return true;
          }
        } catch (e) {
          return false;
        }
      }
      return null;
    },
    titleState() {
      if (this.form.title.length >= 3) {
        return true;
      } else if (this.form.title.length > 0) {
        return false;
      }
      return null;
    },
    descriptionState() {
      if (this.form.description.split(/\s+/).length >= 10) {
        return true;
      } else if (this.form.description.length > 0) {
        return false;
      }
      return null;
    },
    contentShareTextState() {
      if (this.form.customFields.contentShareText.split(/\s+/).length >= 5) {
        return true;
      } else if (this.form.customFields.contentShareText.length > 0) {
        return false;
      }
      return null;
    },
    documentState() {
      if (this.form.customFields.displayContent === 'document' && !this.form.document) {
        return false;
      }
      return true;
    },
    imageState() {
      if ((this.form.customFields.displayContent === 'link' || this.form.customFields.displayContent === 'image') && !this.form.image && !this.form.imageURL) {
        return false;
      }
      return true;
    },
    videoState() {
      if (this.form.customFields.displayContent === 'video' && !this.form.video) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async fetchContent() {
      if (this.urlState) {
        await this.$apollo.queries.prefetchedContentShare.refetch();
      }
    },
    saveSegment(segment) {
      this.form.relatedJobSegment = segment;
      this.$bvModal.hide('segmented-jobs-modal');
    },
    cleanTags(tags) {
      return sanitiseTags(tags);
    },
    addTag(newTag) {
      if (newTag.startsWith('#')) {
        this.tagError = 'Tags contain # by default';
      } else {
        this.tagValue.push(newTag);
        this.tagOptions.push(newTag);
      }
    },
    onTouch() {
      // Reset tagError
      this.tagError = null;
    },
    async addContentCategory(newCategory) {
      try {
        this.contentCategoryError = null;

        // Create new category
        const result = await this.$apollo.mutate({
          mutation: CREATE_CONTENT_CATEGORY,
          variables: {
            input: {
              name: newCategory,
            },
          },
        });

        const category = result.data.createContentCategory;

        // Add to options and selected values
        this.contentCategoryOptions.push(category);
        this.contentCategoryValue = [ ...this.contentCategoryValue, category ];

        // Update form data with stringified IDs
        this.form.customFields.contentCategories = JSON.stringify(this.contentCategoryValue.map((cat) => cat.id));
      } catch (error) {
        console.error('Error creating content category:', error);
        this.contentCategoryError = error.message;
      }
    },

    onContentCategoryTouch() {
      this.contentCategoryError = null;
    },

    onContentCategoryChange(value) {
      // Ensure we have an array
      const newValue = Array.isArray(value) ? value : [ value ].filter(Boolean);
      this.contentCategoryValue = newValue;
      this.form.customFields.contentCategories = JSON.stringify(newValue.map((cat) => cat.id));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/AddContentFormV2.vue